import { useState } from 'react';
import { useAccountTier } from '@/hooks/useAccountTier';
import { UpgradeAccountSheet } from './UpgradeAccountSheet';
import { Button } from '@/components/ui/button';
import { Zap, X } from 'lucide-react';

const DISMISS_KEY = 'quick_upgrade_dismissed_until';

/**
 * Sticky inline banner shown to Quick (anonymous) users prompting them to
 * upgrade. Dismissible for 24h. Mount once near the top of the app.
 */
export function QuickAccountBanner() {
  const { isQuick } = useAccountTier();
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    const until = Number(localStorage.getItem(DISMISS_KEY) ?? 0);
    return until > Date.now();
  });

  if (!isQuick || dismissed) return null;

  return (
    <>
      <div className="w-full bg-amber-50 dark:bg-amber-950/30 border-b border-amber-200 dark:border-amber-900 text-amber-900 dark:text-amber-100 text-sm px-3 py-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Zap className="h-4 w-4 shrink-0" />
          <span className="truncate">
            Та хурдан бүртгэлээр нэвтэрсэн. <strong>Нууц үг алдвал сэргээх боломжгүй.</strong>
          </span>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
            Бүртгэлээ хадгалах
          </Button>
          <Button
            size="sm"
            variant="ghost"
            aria-label="Хаах"
            onClick={() => {
              localStorage.setItem(DISMISS_KEY, String(Date.now() + 24 * 3600 * 1000));
              setDismissed(true);
            }}
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
      <UpgradeAccountSheet open={open} onOpenChange={setOpen} />
    </>
  );
}